import { render, staticRenderFns } from "./VlModalHeader.vue?vue&type=template&id=f1971dd8&scoped=true&"
import script from "./VlModalHeader.vue?vue&type=script&lang=js&"
export * from "./VlModalHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1971dd8",
  null
  
)

export default component.exports